export default __webpack_public_path__ + "static/media/header.5531e8f8.jpg";